import { render, staticRenderFns } from "./CalendarEventFormModal.vue?vue&type=template&id=db28300a&scoped=true&"
import script from "./CalendarEventFormModal.vue?vue&type=script&lang=js&"
export * from "./CalendarEventFormModal.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventFormModal.vue?vue&type=style&index=0&id=db28300a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db28300a",
  null
  
)

export default component.exports